import {ThemeData} from "../clients/shadow/interfaces";

const themes = [
    // The default (10-02): somniworks.dev's palette (its public/style.css :root), so the site's "The chat app" link
    // lands in the same warm black. WCAG contrast: cream text 14.8:1 on paper, muted 5.9:1, gold 8.9:1,
    // black-on-gold buttons 9.4:1. The placeholder is set to the muted ink: MUI's default (cream at 50%) is 4.45:1.
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#e0a95f",
                    "light": "#e9c38f",
                    "dark": "#b8853f",
                    "contrastText": "#0b0a09"
                },
                "background": {
                    "default": "#0b0a09",
                    "paper": "#14120f"
                },
                "text": {
                    "primary": "#ece4d6",
                    "secondary": "#9a907f",
                    "disabled": "rgba(236, 228, 214, 0.5)"
                },
                "divider": "rgba(236, 228, 214, 0.1)",
                // Rooms/users side panels (getPanelColors): raised black, not the fixed #2c2c2c grey.
                "panel": {
                    "background": "#14120f",
                    "color": "#ece4d6"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "#0b0a09"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "#2a2620"
                            }
                        }
                    }
                },
                "MuiInputBase": {
                    "styleOverrides": {
                        "input": {
                            "&::placeholder": {
                                "color": "#9a907f",
                                "opacity": 1
                            }
                        }
                    }
                },
                // MUI dark mode lightens raised Paper (drawers, menus) with a white overlay: grey, not warm black.
                "MuiPaper": {
                    "styleOverrides": {
                        "root": {
                            "backgroundImage": "none"
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "somniworks",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": "somniworks.dev: warm black, cream ink, lamp gold"
        }
    },
    {
        "theme": {
            "palette": {
                "primary": {
                    "main": "#1976d2",
                    "contrastText": "#fff",
                    "light": "#42a5f5",
                    "dark": "#1565c0"
                },
                "background": {
                    "paper": "rgb(245, 249, 253)",
                    "default": "#fff"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(232, 236, 240)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(208, 211, 215)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Nordic Blue",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "light",
                "primary": {
                    "main": "#90caf9",
                    "light": "#e3f2fd",
                    "dark": "#42a5f5",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "#efd0ff",
                    "paper": "#ecc8ff"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(224, 190, 242)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(200, 170, 216)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Dark Fae",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#90caf9",
                    "light": "#e3f2fd",
                    "dark": "#42a5f5",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "#1b1b23",
                    "paper": "rgb(38, 38, 46)"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(36, 36, 43)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(32, 32, 39)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Dark Fairy",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#90caf9",
                    "light": "#e3f2fd",
                    "dark": "#42a5f5",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "#121212",
                    "paper": "rgb(41, 41, 41)"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(38, 38, 38)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(34, 34, 34)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Dark",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#07fcdf",
                    "light": "rgb(56, 252, 229)",
                    "dark": "rgb(4, 176, 156)",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "paper": "#121212",
                    "default": "#121212"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(17, 17, 17)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(15, 15, 15)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Dark New",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#e100a4",
                    "light": "rgb(231, 51, 182)",
                    "dark": "rgb(157, 0, 114)",
                    "contrastText": "#fff"
                },
                "background": {
                    "default": "#1b1b23",
                    "paper": "rgb(29, 28, 35)"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(27, 26, 33)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(24, 23, 29)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Dark Purple",
            "creator": {},
            "comment": "Dark Purple"
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#90caf9",
                    "light": "#e3f2fd",
                    "dark": "#42a5f5",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "#ff4747",
                    "paper": "#ff0000"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(242, 0, 0)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(216, 0, 0)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Fae Red",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "primary": {
                    "main": "#90caf9",
                    "dark": "#42a5f5",
                    "light": "rgb(166, 212, 250)",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "#efd0ff",
                    "paper": "#ecc8ff"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(224, 190, 242)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(200, 170, 216)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Light Fae",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "primary": {
                    "main": "#634e5d",
                    "contrastText": "#FFFFFF",
                    "light": "rgb(130, 113, 125)",
                    "dark": "rgb(69, 54, 65)"
                },
                "background": {
                    "paper": "rgb(242, 242, 242)",
                    "default": "#fff"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(229, 229, 229)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(205, 205, 205)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Light",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "primary": {
                    "main": "#e100a4",
                    "contrastText": "#FFFFFF",
                    "light": "rgb(231, 51, 182)",
                    "dark": "rgb(157, 0, 114)"
                },
                "background": {
                    "default": "rgb(243, 222, 255)",
                    "paper": "#ecc8ff"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(224, 190, 242)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(200, 170, 216)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Pink",
            "type": "system",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": ""
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "rgb(91, 253, 51)",
                    "light": "rgb(123, 253, 91)",
                    "dark": "rgb(63, 177, 35)",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "rgb(98, 47, 245)",
                    "paper": "rgb(92, 121, 226)"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(87, 114, 214)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(78, 102, 192)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Green Oasis",
            "creator": {},
            "comment": "Green Oasis"
        }
    },
    {
        "theme": {
            "palette": {
                "mode": "dark",
                "primary": {
                    "main": "#86aeff",
                    "light": "rgb(158, 190, 255)",
                    "dark": "rgb(93, 121, 178)",
                    "contrastText": "rgba(0, 0, 0, 0.87)"
                },
                "background": {
                    "default": "rgb(81, 123, 229)",
                    "paper": "rgb(67, 114, 238)"
                }
            },
            "components": {
                "MuiCssBaseline": {
                    "styleOverrides": {
                        "*": {
                            "&::-webkit-scrollbar": {
                                "width": "15px",
                                "height": "15px",
                                "backgroundColor": "rgb(63, 108, 226)"
                            },
                            "&::-webkit-scrollbar-thumb": {
                                "height": "40px",
                                "backgroundColor": "rgb(56, 96, 202)"
                            }
                        }
                    }
                }
            }
        },
        "metadata": {
            "name": "Light Blue",
            "creator": {
                "id": "0",
                "name": "system"
            },
            "comment": "Light Blue"
        }
    }
] as ThemeData[]

export const formattedThemes = themes.map(obj => ({
    name: obj.metadata.name,
    ...obj
}))
